//const pdfMake = require("pdfMake")
//import createPdf from "pdfMake"

const pdfMakeX = require("pdfmake/build/pdfmake.js");
const pdfFontsX = require("pdfmake-unicode/dist/pdfmake-unicode.js");
pdfMakeX.vfs = pdfFontsX.pdfMake.vfs;
import * as pdfMake from "pdfmake/build/pdfmake";

var moment = require("moment");

const metadata_colwitdth = 150;

function init_docDef(title, company) {
  var docDef = {
    content: [
      {
        text: title,
        style: "title",
      },
      {
        text: moment().format("LLLL"),
      },
    ],
    footer: function(currentPage, pageCount) {
      return {
        margin: 10,
        columns: [
          {
            fontSize: 9,
            text: [
              {
                text: "--------------------------------------------------------------------------" + "\n",
                margin: [0, 20],
              },
              {
                text:
                  "Erstellt mit SODA© - " +
                  moment().format("LLLL") +
                  " - "+ company.fullname + " - Seite " +
                  currentPage.toString() +
                  " von " +
                  pageCount,
              },
            ],
            alignment: "center",
          },
        ],
      };
    },
    styles: {
      title: {
        fontSize: 32,
        bold: true,
      },
      header: {
        fontSize: 18,
        bold: true,
      },
      subheader: {
        fontSize: 15,
        bold: true,
      },
      metadata: {
        italics: true,
      },
      small: {
        fontSize: 8,
      },
    },
  };
  return docDef;
}

function add_field(docDef, label, value) {
  docDef.content.push({
    columns: [
      { width: metadata_colwitdth, style: "metadata", text: label },
      { width: "*", text: value || "-" },
    ],
    margin: [0, 5, 0, 0],
  });
}


function add_break(docDef) {
  docDef.content.push({
    text: "",
    pageBreak: "after",
  });
}

function add_section_header(docDef, value, tocItem) {
  docDef.content.push({
    text: value,
    style: "header",
    tocItem: tocItem,
    margin: [0, 50, 0, 10],
  });
}

function add_subheader(docDef, value) {
  docDef.content.push({
    text: value,
    style: "subheader",
    margin: [0, 20, 0, 10],
  });
}

function add_company(docDef, company) {
  add_section_header(docDef, "der " + (company.fullname ? company.fullname : company.name));
  var address_string = "";
  if (company.address_street) {
    address_string += company.address_street + " " + (company.address_street_no || "") + "\n";
  }
  if (company.address_zip || company.address_city) {
    address_string += (company.address_zip || "") + " " + (company.address_city || "") + "\n";
  }
  address_string += company.address_country || "";
  if (address_string) {
    add_field(docDef, "Adresse", address_string);
  } else {
    add_field(docDef, "Adresse", null);
  }
  add_field(docDef, "Verantwortlicher TEST", company.responsible_name);
  add_field(docDef, "Rolle des Verantwortlichen", company.responsible_role);
}

const process_specs = require("json-loader!yaml-loader!./specs/process.yml");
//dict der Verfahrenseinträge
var process_specs_dic = Object.assign({}, ...process_specs.fields.map((s) => ({ [s.name]: s })));

function add_process_field(docDef, process, name) {
  if (!process_specs_dic[name]) {
    console.error("MISSING FIELD", name, process_specs_dic);
    return;
  }
  var value = process[name];
  if (value !== null && process_specs_dic[name].multiple === true) {
    value = JSON.parse(value);
    value = value.map((e) => (value.length > 1 ? "• " : "") + e).join("\n");
  }
  add_field(docDef, process_specs_dic[name].label, value);
}

function add_measure_item(docDef, measure) {
  var status = measure.status == "OPEN" ? "offen" : measure.status == "COMPLETED" ? "erledigt" : "unklar";
  docDef.content.push({
    columns: [
      { width: 55, text: status },
      { width: 120, text: measure.label },
      { width: "*", text: measure.description || "-" },
    ],
    margin: [0, 5, 0, 0],
  });
}

function add_measureSet_item(docDef, measureSet) {
  var status = measureSet.status == "OPEN" ? "offen" : measureSet.status == "COMPLETED" ? "erledigt" : "unklar";
  docDef.content.push({
    columns: [
      { width: 55, text: status },
      { width: 120, text: measureSet.measureSet.type },
      { width: "*", text: measureSet.measureSet.description || "-" },
    ],
    margin: [0, 5, 0, 0],
  });
}

function add_process(docDef, process) {
  add_break(docDef);
  var header = "Verfahren Nr. " + process.seq_nr + " - " + process.text_header;
  if (process.archived_at != null) {
    header = [{ text: "[Archiviert] ", italics: true }, header];
  }
  add_section_header(docDef, header, "processesToc");
  add_field(docDef, "Letztes Update", moment(process.updatedAt).format("LLLL"));
  var status =
    process.status == "OPEN"
      ? "offen"
      : process.status == "DOCUMENTED"
      ? "Verfahren dokumentiert"
      : process.status == "PLANNED"
      ? "Maßnahmen spezifiziert"
      : process.status == "COMPLETED"
      ? "Maßnahmen erledigt"
      : "unklar";
  add_field(docDef, "Status", status);
  add_process_field(docDef, process, "text_header");
  add_process_field(docDef, process, "data_category");
  add_process_field(docDef, process, "dept_resp");
  add_process_field(docDef, process, "recipient_category");
  add_process_field(docDef, process, "delete_period");
  add_process_field(docDef, process, "damage_scenario");
  add_process_field(docDef, process, "risk_probability");
  add_process_field(docDef, process, "damage_rate");
  add_process_field(docDef, process, "text_problem");
  add_process_field(docDef, process, "legal_basis");
  add_process_field(docDef, process, "text_legal");
  if (process.measures.items.length > 0) {
    add_subheader(docDef, "To-Do-Liste");
    process.measures.items.sort((a, b) => (a.createdAt > b.createdAt ? 1 : -1));
    for (let measure of process.measures.items) {
      add_measure_item(docDef, measure);
    }
  }
  if (process.measureSets.items.length > 0) {
    add_subheader(docDef, "Allgemeine TOMs");
    for (let measureSet of process.measureSets.items) {
      add_measureSet_item(docDef, measureSet);
    }
  }
}

const measureSet_specs = require("json-loader!yaml-loader!./specs/measureSet.yml");
//dict TOM Felder
var measureSet_specs_dic = Object.assign({}, ...measureSet_specs.fields.map((s) => ({ [s.name]: s })));

function add_measureSet_field(docDef, measureSet, name) {
  add_field(docDef, measureSet_specs_dic[name].label, measureSet[name]);
}

function add_measureSet(docDef, measureSet) {
  add_break(docDef);
  var header = "TOM Nr. " + measureSet.seq_nr + " - " + measureSet.type;
  if (measureSet.archived_at != null) {
    header = [{ text: "[Archiviert] ", italics: true }, header];
  }
  add_section_header(docDef, header, "measureSetsToc");
  add_field(docDef, "Letztes Update", moment(measureSet.updatedAt).format("LLLL"));
  var status =
    measureSet.status == "OPEN"
      ? "offen"
      : measureSet.status == "SPECIFIED"
      ? "Maßnahmen spezifiziert"
      : measureSet.status == "COMPLETED"
      ? "Maßnahmen erledigt"
      : "unklar";
  add_field(docDef, "Status", status);
  add_measureSet_field(docDef, measureSet, "type");
  //add_measureSet_field(docDef, measureSet, 'label')
  add_measureSet_field(docDef, measureSet, "description");
  //add_measureSet_field(docDef, measureSet, 'commentatory')
  measureSet.measures.items.sort((a, b) => (a.createdAt > b.createdAt ? 1 : -1));
  if (measureSet.measures.items.length > 0) {
    add_subheader(docDef, "Einzelmaßnahmen");
    for (let measure of measureSet.measures.items) {
      add_measure_item(docDef, measure);
    }
  }
}

function add_toc(docDef, printOptions) {
  add_section_header(docDef, "Inhaltsverzeichnis");
  if (printOptions.printProcesses) {
    docDef.content.push({
      toc: {
        id: "processesToc",
        title: { text: "Verfahren", style: "subheader" },
      },
    });
  }
  if (printOptions.printMeasureSets) {
    docDef.content.push({
      toc: {
        id: "measureSetsToc",
        title: { text: "Allgemeine TOMs", style: "subheader" },
      },
    });
  }
}

function add_beschreibung(docDef, company) {
  add_break(docDef);
  var header = "Erläuterungen zum Datenschutzmanagementsystem";
  add_section_header(docDef, header, "processesToc");
  add_field(docDef, "Stand des Konzepts", moment().format("LLLL"));
  var header2 = "1. Allgemeine Erläuterungen";
  add_section_header(docDef, header2, "processesToc");
  add_field(docDef, 
    "1.1 Statement", 
    "Das Einhalten der Gesetze und Vorschriften ist ein Grundpfeiler des Erfolges eines jeden Unternehmens.Auch die " + company.fullname + " hat sich verpflichtet, diese als festen Bestandteil ihrer Unternehmenskultur zu implementieren. Die Anforderungen gesetzlicher und rechtlicher Vorgaben werden in allen Prozessen, bei denen personenbezogene Daten verarbeitet werden, sichergestellt.");
  add_field(docDef, 
    "", 
    "Durch eine Implementierung von Datenschutz-Aspekten in alle Bereiche der Prozessgestaltung und -entwicklung wird sichergestellt, dass der Datenschutzrisiken erkannt und mitigiert werden. Hierzu ist es unerlässlich, dass eine Risikoanalyse betrieben wird, die sich auf objektive Kriterien stützt und jeden einzelnen Prozess aber auch das Zusammenspiel der technisch organisatorischen Maßnahmen insgesamt betrachtet.");
  add_field(docDef, 
    "", 
    "Für die Mitigation stehen Konzepte zur Verfügung, die bspw. im Standard-Datenschutzmodell (SDM) beschrieben sind. An diesem Modell orientiert sich das vorliegende Konzept.");
  add_field(docDef, 
    "1.2 Anwendungsbereich", 
    "Das vorliegende Datenschutzkonzept identifiziert die Anforderungen und Risken und gilt für alle Bereiche und \n\
    Mitarbeiter der " + company.fullname + ".");
    var header3 = "2. Umsetzung der Grundsätze des Datenschutzes";
    add_section_header(docDef, header3, "processesToc");
    add_field(docDef, 
      "2.1.	Zweckbindung", 
      "Personenbezogene Daten werden nur verarbeitet, wenn Sie einem ausdrücklichen Zweck dienen. Dieser wird \n\
      bei jedem Verarbeitungsprozess definiert und dokumentiert. ");
    add_field(docDef, 
      "2.2.	Datenminimierung", 
      "Es werden nur solche Daten verarbeitet, die zur Erreichung des Verarbeitungszwecks verarbeitet werden müssen. \n\
      Diese Einschätzung geschieht durch die Dokumentation der Arten und Kategorien von personenbezogenen Daten und die \n\
      Gegenüberstellung dieser Verarbeitung mit dem Zweck.");
    add_field(docDef, 
      "2.3	Richtigkeit ", 
      "Es werden nur personenbezogene Daten verarbeitet, die sachlich richtig und auf dem neuesten Stand sind. Hierzu \n\
      werden Löschkonzepte erarbeitet und umgesetzt. Ebenso werden Datensätze regelmäßig überprüft. Das Recht auf \n\
      Berichtigung und Löschung der Betroffenen (Art. 16 und Art. 17 DSGVO) wird effizient umgesetzt.");
    add_field(docDef, 
      "2.4  Speicherbegrenzung ", 
      "Personenbezogene Daten werden nur so lange gespeichert, wie es zur Erreichung des Verarbeitungszwecks \n\
      erforderlich ist. Jeder Verarbeitungsprozess erhält eine Löschfrist. Nach Zweckerreichung bzw. Ablauf einer \n\
      Aufbewahrungsfrist werden die Daten gelöscht. ");
    add_field(docDef, 
      "2.5  Transparenz  ", 
      "Die Daten der Betroffenen werden nur nach einer erfolgten transparenten Information der Betroffenen verarbeitet. \n\
      Hierzu wird bspw. eine informierte Einwilligung nur dann eingeholt, wenn die Datenverarbeitung vorher transparent \n\
      erläutert wurde. ");
    add_field(docDef, 
      "2.6  Integrität und Vertraulichkeit  ", 
      "Personenbezogene Daten werden nur unter Einhaltung von geeigneten technisch organisatorischen Maßnahmen verarbeitet. \n\
      Diese werden für jeden Verarbeitungsvorgang dokumentiert. Eine Zusammenfassung der technisch Organisatorischen \n\
      Maßnahmen nach Art. 32 DSGVO wird ebenfalls dokumentiert und ist jederzeit einsehbar. ");
    var header4 = "3. Beschreibung Maßnahmen und Empfehlungen";
    add_section_header(docDef, header4, "processesToc");
    add_field(docDef, 
    "Maßnahmen im VVT und TOMs ", 
    "Maßnahmen uns Empfehlungen werden zu jedem dokumentierten Prozess in einer To-Do-Liste aufgeführt. Erledigte Maßnahmen \n\
    werden als „erledigt“ gekennzeichnet. Hierbei ist zu beachten, dass auch ins Auge gefasste zukünftige Entwicklungen und \n\
    Ziele in dieser Liste auftauchen. Daher ist es nicht erforderlich, dass alle Maßnahmen erledigt sein müssen, um einen \n\
    Prozess datenschutzkonform darzustellen.  ");
    var header5 = "4. Datenschutzorganisation";
    add_section_header(docDef, header5, "processesToc");
    add_field(docDef, 
      "4.1 Organisation", 
      "Die Organisation des Datenschutzes wird von der Geschäftsleitung der " + company.fullname + " festgelegt. Oberste Priorität hat die klare \n\
      Zuständigkeit von Personen und Sachthemen in den Bereichen: Geschäftsführung, Personal und IT ");
    add_field(docDef, 
      "4.2 Datenschutzbeauftragter (DSB)", 
      "Wenn ein Datenschutzbeauftragter bestellt wurde, erstellt oder kontolliert dieser Die Dokumentation \n\
      der Verfahren (VVT gem. Art. 30 DSGVO). ");
    add_field(docDef, 
      "4.3 Einbindung des DSB", 
      "Der Datenschutzbeauftragte steht als Ansprechpartner sowohl für Betroffene außerhalb der Organisation \n\
      als auch für Mitarbeiter zur Verfügung. Er betreut die Schulungen der Mitarbeiter und wirkt auf eine Einhaltung \n\
      der datenschutzrechtlichen Vorgaben bei der Geschäftsleitung hin. ");
    add_field(docDef, 
      "4.4 Datenschutz Koordnination", 
      "Ob ein gesamtverantwortlicher Koordinator neben dem Datenschutzbeauftragten ernannt wird, entscheidet die \n\
      Geschäftsleitung. In jedem Fall gibt es einen Ansprechpartner in jeder Abteilung, der den Datenschutzbeauftragten \n\
      in Datenschutzfragen unterstützt. ");
    var header6 = "5. Begriffsbestimmungen";
    add_section_header(docDef, header6, "processesToc");
    add_field(docDef, 
      "", 
      "Nach dem Vorbild des Art. 4 der europäischen Datenschutzgrundverordnung (DS-GVO) liegen diesem Datenschutzkonzept folgende Begriffsbestimmungen zugrunde");
    add_field(docDef, 
      "5.1.	Personenbezogene Daten (vgl. Art. 4 Nr. 1 DS-GVO) ", 
      "Das sind alle Informationen über eine natürliche Person, durch die sie direkt oder indirekt identifiziert wird oder identifizierbar ist. Identifizierbar ist eine Person, sobald zu ihr eine Verbindung mittels personenbezogener Daten hergestellt werden kann, beispielsweise durch Zuordnung einer Kennung, Standortdaten, oder eines oder mehreren besonderen Merkmalen, die Ausdruck der physischen, physiologischen, genetischen, psychischen, wirtschaftlichen, kulturellen oder sozialen Identität der natürlichen Person sind. Dies ist auch dann der Fall, wenn ein Rückschluss auf eine natürliche Person durch eine Kombination von Informationen – wenn auch erst mit zufälligem Zusatzwissen verknüpft – möglich ist. Unter personenbezogenen Daten fallen insbesondere der Name, die Adresse, die Telefonnummer, die E-Mail-Adresse, oder Fotos und Videoaufzeichnungen der natürlichen Person sowie Kunden- und Personaldaten. Eine Identifizierung der Person kann mit Hilfe einer Anonymisierung oder Pseudonymisierung ausgeschlossen werden.");
    add_field(docDef, 
      "5.2.	Besonders schutzwürdige personenbezogene Daten  ", 
      "Dies sind alle Informationen über die rassische und ethische Herkunft, über religiöse oder weltanschauliche Überzeugungen, über politische Meinungen, über eine Gewerkschaftszugehörigkeit, über die Gesundheit oder über die sexuelle Orientierung bzw. das Sexualleben einer betroffenen Person.");
    add_field(docDef, 
      "5.3.	Betroffener", 
      "Unter einem Betroffenen versteht man jede natürliche Person, über die personenbezogene Daten verarbeitet werden.");
    add_field(docDef, 
      "5.4.	Verarbeitung ", 
      "Die Verabreitung personenbezogener Daten (vgl. Art. 4 Nr. 2 DS-GVO) bezeichnet jeden mit oder ohne Hilfe automatisierter Verfahren ausgeführten Vorgang oder jede solche Vorgangsreihe im Zusammenhang mit personenbezogenen Daten wie das Erheben, das Erfassen, die Organisation, das Ordnen, die Speicherung, die Anpassung oder Veränderung, das Auslesen, das Abfragen, die Verwendung, die Offenlegung durch Übermittlung, Verarbeitung oder einer andere Form der Bereitstellung, den Abgleich oder die Verknüpfung, die Einschränkung, das Löschen oder die Vernichtung.");
    add_field(docDef, 
      "5.5.	Einschränkung der Verarbeitung (vgl. Art. 4 Nr. 3 DS-GVO) ", 
      "Eine Einschränkung in diesem Sinne ist die Markierung gespeicherter personenbezogener Daten mit dem Ziel, ihre künftige Verarbeitung einzuschränken.");
    add_field(docDef, 
      "5.6.	Übermittlung ", 
      "Die Übermittlung von Daten ist jede Bekanntgabe von personenbezogenen Daten durch den Verantwortlichen an Dritte.");
    add_field(docDef, 
      "5.7 Profiling (Art. 4 Nr. 4 DS-GVO) ", 
      "Profiling bezeichnet jede Art der automatisierten Verarbeitung personenbezogener Daten, die darin besteht, dass diese personenbezogenen Daten verwendet werden, um bestimmte persönliche Aspekte, die sich auf eine natürliche Person beziehen, zu bewerten, insbesondere um Aspekte bezüglich Arbeitsleistung, wirtschaftliche Lage, Gesundheit, persönliche Vorlieben, Interessen, Zuverlässigkeit, Verhalten, Aufenthaltsort oder Ortswechsel dieser natürlichen Person zu analysieren oder vorherzusagen.");
    add_field(docDef, 
      "5.8.	Anonymisierung", 
      "Anonymisierung meint die Verarbeitung von personenbezogenen Daten in der Gestalt, dass ein Personenbezug auf Dauer nicht mehr hergestellt werden kann oder der Rückschluss auf eine natürliche Person nur mit unverhältnismäßigen Aufwand möglich ist.");
    add_field(docDef, 
      "5.9.	Pseudonymisierung (Art. 4 Nr. 5 DS-GVO) ", 
      "Dies bedeutet  die Verarbeitung personenbezogener Daten in einer Weise, dass die personenbezogenen Daten ohne Hinzuziehung zusätzlicher Informationen nicht mehr einer spezifischen betroffenen Person zugeordnet werden können, sofern diese zusätzlichen Informationen gesondert aufbewahrt werden und technischen und organisatorischen Maßnahmen unterliegen, die gewährleisten, dass die personenbezogenen Daten nicht einer identifizierten oder identifizierbaren natürlichen Person zugewiesen werden.  ");
    add_field(docDef, 
      "5.10.	Verantwortlicher (Art. 4 Nr. 7 DS-GVO) ", 
      "Als Verantwortlichen bezeichnet man die natürliche oder juristische Person, Behörde, Einrichtung oder andere Stelle, die allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten entscheidet; sind die Zwecke und Mittel dieser Verarbeitung durch das Unionsrecht oder das Recht der Mitgliedstaaten vorgegeben, so können der Verantwortliche beziehungsweise die bestimmten Kriterien seiner Benennung nach dem Unionsrecht oder dem Recht der Mitgliedstaaten vorgesehen werden.");
    add_field(docDef, 
      "5.11.	Auftragsverarbeiter (Art. 4 Nr. 8 DS-GVO) ", 
      "Der Auftragsverarbeiter ist eine natürliche oder juristische Person, Behörde, Einrichtung oder andere Stelle, die personenbezogene Daten im Auftrag des Verantwortlichen verarbeitet. ");
    add_field(docDef, 
      "5.12.	Dritter (Art. 4 Nr. 10 DS-GVO) ", 
      "Dritter i.S.d. DSGVO ist eine natürliche oder juristische Person, Behörde, Einrichtung oder andere Stelle, außer der betroffenen Person, dem Verantwortlichen, dem Auftragsverarbeiter und den Personen, die unter der unmittelbaren Verantwortung des Verantwortlichen oder des Auftragsverarbeiters befugt sind, die personenbezogenen Daten zu verarbeiten. ");
    add_field(docDef, 
      "5.13.	Einwilligung (Art. 4 Nr. 11 DS-GVO) ", 
      "Die Einwilligung der betroffenen Person bezeichnet jede freiwillig für den bestimmten Fall, in informierter Weise und unmissverständlich abgegebene Willensbekundung in Form einer Erklärung oder einer sonstigen eindeutigen bestätigenden Handlung, mit der die betroffene Person zu verstehen gibt, dass sie mit der Ver ");
    add_field(docDef, 
      "5.14.	Verletzung des Schutzes personenbezogener Daten (Art. 4 Nr. 12 DS-GVO) ", 
      "ist eine Verletzung der Sicherheit, die zur Vernichtung, zum Verlust, oder zur Veränderung, ob unbeabsichtigt oder unrechtmäßig, oder zur unbefugten Offenlegung von oder zum unbefugten Zugang zu personenbezogenen Daten führt, die übermittelt, gespeichert oder auf sonstige Weise verarbeitet wurden. ");
    add_field(docDef, 
      "5.15.	Gesundheitsdaten (Art. 4 Nr. 15 DS-GVO) ", 
      "Dies sind personenbezogene Daten, die sich auf die körperliche oder geistige Gesundheit einer natürlichen Person, einschließlich der Erbringung von Gesundheitsdienstleistungen, beziehen und aus denen Informationen über deren Gesundheitszustand hervorgehen. ");
    add_field(docDef, 
      "5.16.	Datenschutzvorfall", 
      "Ein solcher bezeichnet alle Umstände, die den Verdacht begründen, dass personenbezogene Daten rechtswidrig durch Mitarbeiter oder Dritte erhoben, übermittelt, kopiert, genutzt oder ausgespäht wurden.");   
    var header7 = "6. Datenschutzkontrolle";
    add_section_header(docDef, header7, "processesToc");
    add_field(docDef, 
      "6.1.	Auditierung", 
      "Für die Gewährleistung eines angemessenen Schutzniveaus und die Konformität mit den geltenden Datenschutzbestimmungen wird bei der " + company.fullname + " regelmäßig die Einhaltung dieser Richtlinie durch Audits und andere Kontrollmechanismen überprüft. Die Kontrolle obliegt dem unternehmensinternen Datenschutzbeauftragten oder interne bzw. externe Prüfer");
    add_field(docDef, 
      "6.2.	Dokumentation", 
      "Die Ergebnisse des Audits sind zu dokumentieren und dem zuständigen Datenschutzbeauftragten oder anderen Prüfern mitzuteilen. Zur Wahrung seiner Berichtpflichten ist der Aufsichtsrat des Unternehmens [falls vorhanden] über die wesentlichen Erkenntnisse der Datenschutzkontrolle zu informieren.");
      add_field(docDef, 
        "6.3.	Abschluss einer Kontrolle", 
        "Eine Datenschutzkontrolle ist erfolgreich beendet, wenn bei allen dokumentierten Mängeln durch die Implementierung geeigneter Maßnahmen Abhilfe geschaffen wurde. Dies ist entsprechend zu überprüfen");
      var header8 = "7. Vertraulichkeit der Datenverarbeitung";
      add_section_header(docDef, header8, "processesToc");
      add_field(docDef, 
        "7.1.	Pflichten der Mitarbeiter", 
        "Alle Beschäftigten der " + company.fullname + " unterliegen der Pflicht den Datenschutz einzuhalten („Datengeheimnis“). Eine unbefugte Erhebung, Verarbeitung oder Nutzung personenbezogener Daten ist den Beschäftigten untersagt. Unbefugt handelt ein Mitarbeiter, wenn er personenbezogene Daten verarbeitet, ohne dazu zur Erfüllung seiner Tätigkeit beauftragt, angewiesen oder berechtigt zu sein. ");
      add_field(docDef, 
        "7.2.	Verpflichtungserklärung", 
        "Alle Beschäftigten der " + company.fullname + " müssen sich vor Beginn ihrer Tätigkeit schriftlich zur Vertraulichkeit verpflichten. Dabei ist zu versichern, dass die im Rahmen der Tätigkeit erlangten personenbezogene Daten nicht für private oder wirtschaftliche Interessen genutzt, an Unbefugte weitergeleitet oder in sonstiger Weise zugänglich gemacht werden. Diese Pflicht besteht über das Ende des Beschäftigungsverhältnisses hinaus. Bei Aufnahme der Tätigkeit ist der Beschäftigte über seine Pflicht zur Vertraulichkeit zu informieren und schriftlich zu verpflichten.");
      add_field(docDef, 
        "7.3.	„Need-to-know“-Prinzip", 
        "Um ein hohes Maß an Vertraulichkeit zu gewährleisten, darf den Beschäftigten der " + company.fullname + " Zugang zu personenbezogenen Daten nur in dem Umfang eingeräumt werden, der konkret zur Erfüllung ihrer Tätigkeiten notwendig ist („Need-to-know-Prinzip“). Es ist ein detailliertes und vollständiges Berechtigungskonzept zu etablieren und sorgfältig zu pflegen, durch das die Beschäftigten entsprechend ihrer Rollen und Zuständigkeiten mit festgelegten Zugangsberechtigungen ausstattet sind.");
      var header9 = "8. Technisch organisatorische Maßnahmen, Change Management, Fortbildung";
      add_section_header(docDef, header9, "processesToc");
      add_field(docDef, 
        "8.1.	Sicherstellung", 
        "Die " + company.fullname + " stellt jederzeit den Schutz personenbezogener Daten vor unberechtigtem Zugriff, Veränderung, Weitergabe, Verlust oder Zerstörung sicher. Hierzu werden von der " + company.fullname + " geeignete technische organisatorische Maßnahmen, wie bspw. Pseudonymisierung, Beschränkung der Berechtigung oder Anonymisierung in die einzelnen Prozesse implementiert.");
      add_field(docDef, 
        "8.2.	Change-Management", 
        "Änderungen an IT-Assets der " + company.fullname + " werden im Vorfeld auf die o.a. Maßnahmen überprüft. Diese werden nur dann vorgenommen, wenn das IT-Sicherheits-Niveau durch die Änderung der Assets nicht negativ beeinflusst wird. ");
      add_field(docDef, 
        "8.3 Schulung und Fortbildung", 
        "8.5.	Zur Sicherstellung der o.a. Maßnahmen werden alle Mitarbeiter der " + company.fullname + ", die  personenbezogene Daten verarbeiten, in regelmäßigen Abständen geschult und fortgebildet. ");
      var header10 = "9. Datenschutz-Folgenabschätzung, Datenschutzvorfall";
      add_section_header(docDef, header10, "processesToc");
      add_field(docDef, 
        "9.1.	Datenschutz-Folgenabschätzung DSFA gem. Art. 35 DSGVO", 
        "Eine DSFA ist immer dann durchzuführen, wenn ein Prozess in der Bewertung des Betroffenenrisikos ein „hohes Risiko“ ergibt. Dieses Risiko wird in der Organisation durch eine Matrix aus Risikoschwere (bspw. der Schutzbedarf der Daten) und Risikowahrscheinlichkeit ermittelt. Daneben werden spezielle gesetzliche Verarbeitungsvorgänge beachtet, in denen, oder in einer Kombination, eine DSFA vorgeschrieben ist. ");
      add_field(docDef, 
        "9.2.	Durchführung der DSFA", 
        "Die DSFA wird durch speziell benannte Personen (bspw. ext. / interner DSB) erstellt und im Wege des 4-Augen-Prinzips kontolliert.");
      add_field(docDef, 
        "9.3.	Datenschutzvorfälle", 
        "9.4.	Im Falle eines Datenschutzvorfalls, also einem Verstoß gegen die beschrieben Maßnahmen oder gegen andere Regelungen zum Schutz personenbezogener Daten, ist der verantwortliche Mitarbeiter verpflichtet, den Datenschutzvorfall umgehend seinem Vorgesetzten sowie ggf. dem Datenschutzbeauftragten zu melden. Besteht für den jeweiligen Datenschutzvorfall eine Meldepflicht gegenüber den Aufsichtsbehörden, hat die Geschäftsführung der " + company.fullname + " diese umgehend zu erfüllen.");
      var header11 = "10. Aktualität; Änderungen";
      add_section_header(docDef, header11, "processesToc");
      add_field(docDef, 
        "10.1.	Anpassung", 
        "Die oben genannten Maßnahmen werden fortlaufend überprüft und angepasst. ");
      add_field(docDef, 
        "10.2. Änderungen", 
        "Änderungen sind auch formlos möglich (bspw. durch Wegstreichen oder hinzufügen von weiteren Informationen zu diesem Dokument).");
      }


function generatePDF(company, printOptions, callback) {
  var title = printOptions.printProcesses
    ? "Verfahrensverzeichnis"
    : "Technisch organisatorische Maßnahmen gem. Art. 32 DSGVO";
  var docDef = init_docDef(title, company);
  add_company(docDef, company);
  if (company.processes.items.length === 0) {
    printOptions.printProcesses = false;
  }
  if (company.measureSets.items.length === 0) {
    printOptions.printMeasureSets = false;
  }
  add_toc(docDef, printOptions);
  add_beschreibung(docDef, company);
  if (printOptions.printProcesses) {
    var processes = company.processes.items;
    processes.sort((a, b) => {
      return a.seq_nr - b.seq_nr;
    });
    for (let process of processes) {
      if (process.archived_at == null || printOptions.printArchived == true) {
        add_process(docDef, process);
      }
    }
  }
  if (printOptions.printMeasureSets) {
    var measureSets = company.measureSets.items;
    measureSets.sort((a, b) => a.seq_nr - b.seq_nr);
    for (let measureSet of measureSets) {
      if (measureSet.archived_at == null || printOptions.printArchived == true) {
        add_measureSet(docDef, measureSet);
      }
    }
  }
  //pdfMake.createPdf(docDef).download('Verzeichnis.pdf')
  pdfMake.createPdf(docDef).getBuffer((buffer) => {
    callback(buffer, moment().format());
  });
}

export { generatePDF };
